import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import HeroCardLayout from "../layout/HeroCardLayout";
import { APISelector } from "../../utils/miscEndpoints";
import "../../styles/components/entryflow/Selector.css";

interface Props {
  selector: APISelector;
  onContinue: (resLinkParamId: string) => void;
}

const SelectorSelectView: React.FC<Props> = ({ selector, onContinue }) => {
  const { t } = useTranslation();
  const [selectedResLink, setSelectedResLink] = useState<string | null>(null);
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  const formRef = useRef<HTMLFormElement>(null);

  const handleContinue = (e: React.FormEvent) => {
    e.preventDefault();
    if (selectedResLink) {
      onContinue(selectedResLink);
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && selectedResLink) {
      e.preventDefault();
      onContinue(selectedResLink);
    }
  }

  return (
    <form 
      ref={formRef}
      className="selector-select-container" 
      onSubmit={handleContinue} 
      onKeyDown={handleKeyDown}
      tabIndex={-1}
    >
      {selector.selector_title && (
        <div className="selector-select-title">{selector.selector_title}</div>
      )}
      {selector.selector_subtitle && (
        <div className="selector-select-subtitle">
          {selector.selector_subtitle}
        </div>
      )}

      <div className="selector-entries-list">
        {selector.entries.map((entry, i) => (
          <div
            key={i}
            className={`selector-entry-item ${
              selectedIndex === i ? "selected" : ""
            }`}
            onClick={() => {
              setSelectedIndex(i);
              setSelectedResLink(entry.res_link_params_id);
              formRef.current?.focus();
            }}
          >
            <div className="selector-entry-content">
              <div className="selector-entry-title">{entry.title}</div>
              {entry.subtitle && (
                <div className="selector-entry-subtitle">{entry.subtitle}</div>
              )}
            </div>
          </div>
        ))}
      </div>

      <button
        type="submit"
        disabled={!selectedResLink}
        className="entryflow-submit-button selector-continue-button"
      >
        {t("selector.continue")}
      </button>
    </form>
  );
};

const SelectorSelectViewOnlyComponent: React.FC = () => {

  const selector: APISelector = {
    selector_id: "sel_001",
    organization_id: "org_123",
    pre_selection_copy: "Please choose one of the options below",
    selector_title: "What brings you to us?",
    selector_subtitle: "Please choose the option that best describes your reason for reaching out.",
    entries: [
        {
        title: "Basic Plan",
        subtitle: "Free forever",
        res_link_params_id: "basic_001",
        },
        {
        title: "Press",
        subtitle: "I'm inviting Anatoly or a Solana team member to speak at a conference, podcast, or event.",
        res_link_params_id: "pro_002",
        },
        {
        title: "Enterprise",
        subtitle: "Custom solutions",
        res_link_params_id: "enterprise_003",
        },
        {
        title: "Student Plan",
        subtitle: "Discounted for students",
        res_link_params_id: "student_004",
        },
        {
        title: "Family Plan",
        subtitle: "Up to 5 members",
        res_link_params_id: "family_005",
        },
    ],
  };

  return (
    <HeroCardLayout>
      <SelectorSelectView selector={selector} onContinue={() => {}} />
    </HeroCardLayout>
  );
};

export default SelectorSelectView;
export { SelectorSelectViewOnlyComponent };
